//-----------------------------------------------------------------------------
//  Copyright (c) 2019 by Dell Inc.
//
// All rights reserved.  This software may not be copied, disclosed,
// transferred, or used except in accordance with a license granted
// by Dell Inc.  This software embodies proprietary information
// and trade secrets of Dell Inc.
//
//-----------------------------------------------------------------------------

import React from 'react';
import styled from '@emotion/styled';
import WarningIcon from '../icons/WarningIcon';

const Empty = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #aaaaaa;
  height: 100%;
`;

const Title = styled.h2`
  margin-top: 0.8rem;
  font-weight: 500;
  font-size: 1.75rem;
`;

const WarningContainer = styled.p`
  text-align: center;
  height: 2rem;
  margin: 0px;
`;

export function TableEmptyOverlay() {
  return (
    <Empty data-testid={'table-empty-overlay'}>
      <WarningContainer>
        <WarningIcon />
      </WarningContainer>
      <Title>No Data Available</Title>
    </Empty>
  );
}
